/**
 * Created by Daniel Wang on 08/31/2019.
 * Description: Add contact page
 * ------ maintenance history ------
 */

import { Component, OnInit, Input } from '@angular/core';
import { CalendarSubChromeConfig } from './calendar-sub-chrome.model';
import { CalendarDialogOpenOptions, CalendarDialogType } from '../../calendar-dialog/calendar-dialog.model';
import { CalendarDialogService } from '../../calendar-dialog/calendar-dialog.service';

@Component({
    selector: 'calendar-sub-chrome',
    templateUrl: './calendar-sub-chrome.component.html',
    styleUrls: ['./calendar-sub-chrome.component.scss']
})
export class CalendarSubChromeComponent implements OnInit {
    @Input() config: CalendarSubChromeConfig;
    screenInfo: any = {};

    constructor(
        private _calendarDialogService: CalendarDialogService,
    ) { }

    ngOnInit() {
        this.screenInfo.name = 'All Events';
    }

    onNewEventClick() {
        const _calendarDialogOpenOptions = new CalendarDialogOpenOptions();
        _calendarDialogOpenOptions.openType = CalendarDialogType.NewEvent;
        _calendarDialogOpenOptions.isPluginInEditEventMode = false;
        this._calendarDialogService.dialogOpen$.next(_calendarDialogOpenOptions);
    }

}
